/**
 * Статус запроса
 */
export enum DeclarationPropertiesViews {
  /**
   * Доступно для редактирования.
   */
  Editable = 0,

  /**
   * Только чтение.
   */
  Readonly = 1,

  /**
   * Скрытое.
   */
  Hidden = 2
}
